
// native
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

//addon
import * as uaParser from 'ua-parser-js';

// service
import { ApiService } from './api.service';
import { GlobalsService } from './globals.service';

// models
import { IAppConfig, IUser } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user$: BehaviorSubject<IUser> = new BehaviorSubject<IUser>(null);

  appConfig: IAppConfig;

  constructor(
    private apiService: ApiService,
    private globalsService: GlobalsService
  ) { }

  getUserInfo(): void {
    const url = `${this.globalsService.appConfig.environment.baseUrls.services}/users/info_smartcite`;
    this.apiService.get(url).subscribe((user: IUser) => {
      this.user$.next(user);
    }, err => {
      this.globalsService.initialLoading$.next(false);
    });
  }

  registerUser(): void {
    const parser = new uaParser.UAParser();
    const osName = parser.getOS().name;
    const osVersion = parser.getOS().version;
    const browser = parser.getBrowser();
    const engine = parser.getEngine().name;

    const body = {
      client_type: this.globalsService.appConfig.environment.clientName,
      client_id: `${browser?.name}:${engine}`,
      build_version: `${browser?.name} ${engine} ${browser?.version}`,
      install_version: this.globalsService.appConfig.buildVersion,
      os: osName,
      os_version: osVersion
    };

    const url = `${this.globalsService.appConfig.environment.baseUrls.services}/user_account/register_app`;

    this.apiService.post(url, body).subscribe();
  }
}